import { createSlice } from "@reduxjs/toolkit";
import { LOGOUT_BROADCAST_KEY } from "../../../constants/authStorage";

const initialState = {
  token: null,
  user: null,
  error: false,
  selectedCompany: null, // Selected company for multi-company admins
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken } = action.payload;
      state.token = accessToken;
      state.user = action.payload;
      state.error = false;
    },
    updateFeedback: (state) => {
      if (state.user) state.user.hasGivenFeedback = true;
    },
    logoutUser: () => {
      // Notify other tabs before wipe (storage event does not fire in this tab).
      try {
        localStorage.setItem(LOGOUT_BROADCAST_KEY, String(Date.now()));
      } catch (_) {
        // Ignore quota / private-mode failures; local clear still proceeds.
      }
      localStorage.clear();
      sessionStorage.clear();
      return initialState;
    },
    isErrorRedirect: (state, action) => {
      const { redirect } = action.payload;
      state.error = redirect;
    },
    setAvatar: (state, action) => {
      const { avatar } = action.payload;
      state.user = {
        ...state.user,
        avatar,
      };
    },
    setName: (state, action) => {
      const { fname, lname } = action.payload;
      state.user = {
        ...state.user,
        fname,
        lname,
      };
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
      // Persist to localStorage
      if (action.payload) {
        localStorage.setItem("selectedCompany", action.payload);
      } else {
        localStorage.removeItem("selectedCompany");
      }
    },
    logoutAuth: (state, action) => {
      return initialState;
    },
  },
});

export const {
  setCredentials,
  logoutUser,
  updateFeedback,
  isErrorRedirect,
  setAvatar,
  logoutAuth,
  setName,
  setSelectedCompany,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentError = (state) => state.auth.error;
export const selectSelectedCompany = (state) => state.auth.selectedCompany;